import { render, staticRenderFns } from "./TableMoveSelected.vue?vue&type=template&id=41be7f95"
import script from "./TableMoveSelected.vue?vue&type=script&lang=js"
export * from "./TableMoveSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports